import {
  Button,
  Card as MuiCard,
  Grid,
  Typography,
  Divider as MuiDivider,
  Box
} from '@mui/material'
import styled from '@emotion/styled'
import { spacing } from '@mui/system'

const Card = styled(MuiCard)(spacing)

const Divider = styled(MuiDivider)(spacing)
const CurrentPlan = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  '& > *': {
    width: '100%',
    maxWidth: '200px',
    height: theme.spacing(80),
    borderStyle: 'solid',
    borderWidth: '2px',
    borderColor: '#69d9d4',
    backgroundColor: '#c4edec'
  }
}))

function SubscrionInfoComponent({
  onSubmit,
  okText,
  plansData,
  entitlementData,
  onCancelPlanClick,
  changePlanText
}) {
  if (plansData == undefined) plansData = []

  const handleSubmit = (plans) => {
    onSubmit(plans)
  }

  return (
    <div>
      <Grid container spacing={2}>
        {plansData.map((plans, i) => (
          <Grid item xs={4} key={plans._id}>
            <CurrentPlan>
              <Card elevation={24} style={{ height: 'auto' }}>
                <div>
                  <Grid
                    spacing={0}
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                    container
                  >
                    <Divider my={1} />
                    <Grid item>
                      <Typography variant="h5" style={{ color: '#065656' }}>
                        {plans?.name}
                      </Typography>
                    </Grid>

                    {/* <Grid item style={{ paddingTop: 10 }}>
                                            <Grid container alignItems="center" direction="column">
                                                <Typography style={{ fontSize: 12, color: '#065656' }}>
                                                    Free Users &#8194;
                                                </Typography>
                                                <Typography
                                                    style={{
                                                        fontSize: 22,
                                                        fontWeight: 'bold',
                                                        color: '#065656',
                                                    }}
                                                >
                                                    {plans?.free_users > 0 ? plans?.free_users : 0}
                                                </Typography>
                                            </Grid>
                                        </Grid> */}
                    {/* <Grid item style={{ paddingTop: 10 }}>
                                            <Grid container alignItems="center" direction="column">
                                                <Typography style={{ fontSize: 12, color: '#065656' }}>
                                                    Max Users &#8194;
                                                </Typography>
                                                <Typography
                                                    style={{
                                                        fontSize: 22,
                                                        fontWeight: 'bold',
                                                        color: '#065656',
                                                    }}
                                                >
                                                    {plans?.max_users}
                                                </Typography>
                                            </Grid>
                                        </Grid> */}
                    <Grid item style={{ paddingTop: 10 }}>
                      <Grid container alignItems="center" direction="column">
                        <Typography style={{ fontSize: 12, color: '#065656' }}>
                          Users &#8194;
                        </Typography>
                        <Typography
                          style={{
                            fontSize: 22,
                            fontWeight: 'bold',
                            color: '#065656'
                          }}
                        >
                          Unlimited
                        </Typography>
                      </Grid>
                    </Grid>
                    {/* <Grid item style={{ paddingTop: 10 }}>
                                            <Grid container alignItems="center" direction="column">
                                                <Typography style={{ fontSize: 12, color: '#065656' }}>
                                                    Price &#8194;
                                                </Typography>
                                                <Typography
                                                    style={{
                                                        fontSize: 22,
                                                        fontWeight: 'bold',
                                                        color: '#065656',
                                                    }}
                                                >
                                                    Rs {plans?.price_per_user} / User
                                                </Typography>
                                            </Grid>
                                        </Grid> */}
                    {/* <Grid item style={{ paddingTop: 10 }}>
                                            <Grid container alignItems="center" direction="column">
                                                <Typography style={{ fontSize: 12, color: '#065656' }}>
                                                    Fixed Price &#8194;
                                                </Typography>
                                                <Typography
                                                    style={{
                                                        fontSize: 22,
                                                        fontWeight: 'bold',
                                                        color: '#065656',
                                                    }}
                                                >
                                                    Rs {plans?.fixed_charge}
                                                </Typography>
                                            </Grid>
                                        </Grid> */}
                    <Grid item style={{ paddingTop: 10 }}>
                      {/* <Grid container alignItems="center" direction="column">
                                                <Typography style={{ fontSize: 12, color: '#065656' }}>
                                                    Duration &#8194;
                                                </Typography>
                                                <Typography
                                                    style={{
                                                        fontSize: 22,
                                                        fontWeight: 'bold',
                                                        color: '#065656',
                                                    }}
                                                >
                                                    {plans?.plan_duration} Days
                                                </Typography>
                                            </Grid> */}
                    </Grid>

                    <Grid
                      style={{ paddingTop: 20 }}
                      direction="column"
                      justifyContent="center"
                      alignItems="center"
                      container
                    >
                      {entitlementData == null ||
                      entitlementData?.active === 'Cancelled' ? (
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          onClick={() => {
                            handleSubmit(plans)
                          }}
                        >
                          {okText}
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          color="secondary"
                          size="small"
                          onClick={() => {
                            onCancelPlanClick()
                          }}
                        >
                          {changePlanText}
                        </Button>
                      )}
                    </Grid>
                    <Box height={15} />
                  </Grid>
                </div>
              </Card>
            </CurrentPlan>
          </Grid>
        ))}
      </Grid>
    </div>
  )
}

export default SubscrionInfoComponent
